export const getFileSize = (size: number) => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })

  if (size >= 1_000_000) {
    return [numberFormatter.format(size / 1_000_000), 'GB']
  }

  if (size >= 1_000) {
    return [numberFormatter.format(size / 1_000), 'MB']
  }

  const wholeNumberFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
  })
  return [wholeNumberFormatter.format(size), 'KB']
}
